import {Button} from "@always_faithful/shadcn/components/ui/button.js";
import {useUserServiceApi} from "../api/auth/auth-api.js";
import {Link, useLocation, useMatchRoute} from '@tanstack/react-router'
import {useEffect, useState} from "react";

function LogOutButton() {
    const { logoutUser, accessToken, refreshToken } = useUserServiceApi();
    const location = useLocation();
    const [currentPath, setCurrentPath] = useState(location.pathname);

    useEffect(() => {
        setCurrentPath(location.pathname);
    }, [location.pathname]);

    const matchRoute = useMatchRoute()
    const isLoginPage = matchRoute({ to: "/login"})
    const isRegisterPage = matchRoute({to: "/register"})
    const isAboutPage = matchRoute({ to: "/about"})
    const isVacanciesPage = matchRoute({ to: "/vacancies"})
    const isAccountPage = matchRoute({ to: "/user"});
    const isAdminLogin = matchRoute({ to: "/admin/global-login"})
    const isCurrAdminLogin = matchRoute({ to: "/admin/current-admin-login"})
    const isBlogPostPage = matchRoute({ to: "/post/$id"})
    const isAdminPanel = matchRoute({ to: "/admin/home-page"})
    const isBlogEditForm = matchRoute({ to: "/admin/blog/edit"})
    const isReportEditForm = matchRoute({ to: "/admin/report/edit"})
    const isReportModal = matchRoute({to: "/report/$id"})
    const isPolicyPage = matchRoute({to: "/policy-page"})
    const resumeRoutes = new Set([
        "/create-resume",
        "/resume/edit",
        "/resume/view",
        "/resume/view/file",
        "/resume/upload"
    ]);

    const vacancyRoutes = new Set([
        "/create-vacancy",
        "/vacancy/edit",
    ]);

    const isApplyPage = matchRoute({ to: "/vacancy/apply/$id"})
    const viewVacancy = matchRoute({to: "/vacancy/view/$id"});
    const isResumeRoute = [...resumeRoutes].some(route => currentPath.startsWith(route));
    const isVacancyRoute = [...vacancyRoutes].some(route => currentPath.startsWith(route));

    useEffect(() => {
        refreshToken;
    }, [accessToken]);

    return(
        <>
            {accessToken ?
                <>
                    {isAccountPage || isAdminPanel ?
                        <Button
                            className="w-full sm:w-auto px-6 pt-1 mt-3 font-medium text-red-500 outline-2 outline-offset-2 border-solid bg-transparent hover:text-white "
                            onClick={() => logoutUser.mutate()}
                        >
                            Вийти
                        </Button> :
                        <Link to={sessionStorage.getItem("userType") === "admin" ? "/admin/home-page" : "/user"}
                              className={`[&.active]:font-bold outline-solid rounded-md outline-2 outline-offset-2 px-6 pt-1 mt-3 
                                  ${isLoginPage || isRegisterPage || isAboutPage || isVacancyRoute || isResumeRoute || isVacanciesPage || isReportModal ? "hover:text-gray-900" : "hover:text-chromatic"}
                                  ${isBlogPostPage || isAdminLogin || isCurrAdminLogin || isAdminPanel || isApplyPage || viewVacancy || isBlogEditForm || isReportEditForm || isPolicyPage ? "text-gray-900" : "text-white"}
                              `}>
                            {sessionStorage.getItem("userType") === "admin" ? "Управління" : "Акаунт"}
                        </Link>
                    }
                    </> :
                    <>
                        {isLoginPage ?
                            <Link to="/register"
                                className={`[&.active]:font-bold outline-solid rounded-md outline-2 outline-offset-2 px-6 pt-1 mt-3 
                                    ${isLoginPage || isRegisterPage || isAboutPage || isVacancyRoute || isResumeRoute || isVacanciesPage || isReportModal ? "hover:text-gray-900" : "hover:text-chromatic"}
                                    ${isAboutPage || isBlogPostPage || isAdminLogin || isCurrAdminLogin || isAdminPanel || viewVacancy || isBlogEditForm || isReportEditForm || isPolicyPage? "text-gray-900" : "text-white"}
                            `}>
                                Реєстрація
                            </Link> :
                            <Link to="/login"
                                  className={`[&.active]:font-bold outline-solid rounded-md outline-2 outline-offset-2 px-6 pt-1 mt-3 
                                     ${isLoginPage || isRegisterPage || isAboutPage || isVacancyRoute || isResumeRoute || isVacanciesPage || isReportModal ? "hover:text-gray-900" : "hover:text-chromatic"}
                                     ${isAboutPage || isBlogPostPage || isAdminLogin || isCurrAdminLogin || isAdminPanel || viewVacancy || isBlogEditForm || isReportEditForm || isPolicyPage ? "text-gray-900" : "text-white"}
                                `}>
                                Увійти
                            </Link>
                        }
                    </>
            }
        </>
    )
}

export default LogOutButton;